import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import useResponsive from '../../../../../../hooks/use-responsive';
import { toArray } from '../../../../../../services/components';
import Pagination from '../../../Pagination';
import { ORIENTATION_LEFT, ORIENTATION_RIGHT } from '../../constants/base';
import { displayCarouselIndicators, getAutoScrollInterval, getPageSize, showIndicators } from '../../services';
import { BaseCarouselPropTypes, BaseCarouselDefaultProps } from '../../types/base';
import './VerticalCarousel.css';
var defaultProps = _objectSpread(_objectSpread({}, BaseCarouselDefaultProps), {}, {
  orientation: ORIENTATION_RIGHT
});
export default function VerticalCarousel(_ref) {
  var items = _ref.items,
    size = _ref.size,
    autoScroll = _ref.autoScroll,
    responsive = _ref.responsive,
    continuous = _ref.continuous,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    className = _ref.className,
    orientation = _ref.orientation,
    renderItemContainer = _ref.renderItemContainer;
  if (_isEmpty(items)) {
    return null;
  }
  var _useResponsive = useResponsive(),
    isMobile = _useResponsive.isMobile;
  var pageSize = getPageSize(items, size, responsive);
  var displayControls = displayCarouselIndicators(pageSize, items, {
    isMobile: isMobile
  });
  var autoScrollInterval = getAutoScrollInterval(autoScroll, {
    items: items,
    pageSize: pageSize
  });
  var controls = /*#__PURE__*/React.createElement(Grid.Column, {
    className: "vertical-carousel-controls",
    width: isMobile ? 16 : 1,
    verticalAlign: "middle",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Pagination.Indicators, {
    compact: true,
    fitted: true,
    borderless: true,
    vertical: !isMobile,
    onlyPageIndicators: true,
    pageIndicatorIcon: pageIndicatorIcon,
    show: showIndicators(pageSize, items)
  }), /*#__PURE__*/React.createElement(Pagination.Play, {
    basic: true
  }));
  var carousel = /*#__PURE__*/React.createElement(Grid.Column, {
    width: !displayControls || isMobile ? 16 : 15,
    textAlign: "center",
    className: "vertical-carousel-items"
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: pageSize,
    verticalAlign: "middle",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Pagination.Elements, null, function (activeItems) {
    return activeItems.map(renderItemContainer);
  })));
  var content = [carousel];
  if (displayControls) {
    content = orientation === ORIENTATION_RIGHT ? [carousel, controls] : [controls, carousel];
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel vertical-carousel ".concat(className)
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageSize: pageSize,
    items: toArray(items),
    carousel: true,
    continuous: continuous,
    autoScroll: !!autoScroll,
    autoScrollInterval: autoScrollInterval
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: content.length
  }, /*#__PURE__*/React.createElement(Grid.Row, null, content))));
}
VerticalCarousel.defaultProps = defaultProps;